/** Workflow 输出中的表格操作数据 */
export interface WorkflowTableOutput {
  readonly tableId?: string;
  /** Directus collection 名称，用于查询表格数据的目标集合 */
  readonly collection?: string;
  readonly changedCells?: readonly any[];
  readonly version?: string;
  readonly action?: 'create' | 'update' | 'delete';
}

/**
 * 从 AI 消息文本中解析 workflow 结构化输出
 *
 * 支持两种格式：
 * 1. workflowTrace.outputs 中直接包含 table_id 等字段
 * 2. 消息文本中嵌入的 ```json 代码块（兜底方案）
 */
export const parseWorkflowOutput = (
  message: string,
  workflowTrace?: any
): WorkflowTableOutput | null => {
  // 优先从 workflowTrace 提取
  if (workflowTrace?.outputs) {
    const outputs = workflowTrace.outputs;
    if (outputs.table_id || outputs.tableId) {
      return {
        tableId: outputs.table_id ?? outputs.tableId,
        collection: outputs.collection,
        changedCells: outputs.items ?? outputs.changed_cells ?? outputs.changedCells ?? [],
        version: outputs.version,
        action: outputs.action ?? 'update',
      };
    }
  }

  // 兜底：从文本中提取 JSON 块
  return parseJsonFromMessage(message);
};

/**
 * 从消息文本中提取嵌入的 JSON 块
 *
 * 匹配格式:
 * ```json
 * { "table_id": "xxx", "items": [...] }
 * ```
 */
const parseJsonFromMessage = (message: string): WorkflowTableOutput | null => {
  try {
    // 匹配 ```json ... ``` 代码块
    const jsonBlockRegex = /```json\s*\n?([\s\S]*?)\n?\s*```/g;
    let match: RegExpExecArray | null;

    while ((match = jsonBlockRegex.exec(message)) !== null) {
      try {
        const parsed = JSON.parse(match[1]);
        if (parsed.table_id || parsed.tableId) {
          return {
            tableId: parsed.table_id ?? parsed.tableId,
            collection: parsed.collection,
            changedCells: parsed.items ?? parsed.changed_cells ?? parsed.changedCells ?? [],
            version: parsed.version,
            action: parsed.action ?? 'update',
          };
        }
      } catch {
        // 单个块解析失败，继续尝试下一个
        continue;
      }
    }

    return null;
  } catch {
    return null;
  }
};